import React from 'react';
import FieldValidation from '../Fragments/FieldValidation';
import FieldError from '../Fragments/FieldError';
import HelpIcon from './HelpIcon';

let Validation = require('../Managers/Validation.js');

const PasswordInput = React.createClass({
    propTypes: {
        fieldName:          React.PropTypes.string.isRequired,
        helpText:           React.PropTypes.string,
        question:           React.PropTypes.string.isRequired,
        validationCallback: React.PropTypes.func,
        checkMatch:         React.PropTypes.bool,
        checkAgainst:       React.PropTypes.string,
    },

    getInitialState() {
        return {
            isHelpVisible: false,
            activeValue:null,
            hasError: false,
            errors: null,
        };
    },

    helpVisibility() {
        if (this.state.isHelpVisible) {
            this.setState({
                isHelpVisible: false,
            });
        } else {
            this.setState({
                isHelpVisible: true,
            });
        }
    },

    setActiveValue(e) {
        this.setState({
            activeValue : e.target.value
        });
    },

    getDomId() {
        return this.props.fieldName;
    },

    onPasswordBlurEvent(event) {
        this.setState({
            activeValue: event.target.value,
            hasError: false
        });
        let validation = Validation.validate(this.getDomId(), event.target.value)[0];
        this.setState(validation);
        this.props.validationCallback(validation.isValid);
    },

    checkMatch(event) {
        let valueToCheck = document.getElementById(this.props.checkAgainst).value;
        let errorArray = [];
        if (event.target.value !== valueToCheck) {
            errorArray.push(["Passwords are not the same"]);
            this.setState({
                hasError: true,
                errors: errorArray,
            });
        } else {
            errorArray = [];
            this.setState({
                hasError: false,
                errors: errorArray,
            });
        }
    },

    render() {
        return (
            <question-row class="no-border password-row">
                <div className="question-main">
                    <div className="question-top">
                        <label>{this.props.question}</label>
                        {this.props.helpText ?  <HelpIcon onClick={this.toggleHelpText} /> : null }
                    </div>
                    <div className="question-input">
                        <input
                            name={this.props.fieldName}
                            id={this.props.fieldName}
                            onChange={this.setActiveValue}
                            type="password"
                            className="form-control"
                            onBlur={this.props.checkMatch === true ? this.checkMatch : this.onPasswordBlurEvent}
                        />
                        {this.state.isHelpVisible ? (
                            <div className="hint-container">
                                <div className="hint">
                                    <div className="arrow arrow-left" />
                                    {this.props.helpText}
                                </div>
                            </div>
                        ) : null}
                        {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
                    </div>
                </div>
                <div className="question-extra">
                    <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                </div>
            </question-row>
        );
    }
});

export default PasswordInput;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/PasswordInput.js
 **/